export default "__VITE_ASSET__a9dcede8__"